import { LogoWithName } from 'apps/components/toolbar/LogoWithName'
import { useEmbeddedOnboarding } from 'components/hooks/employer_onboarding/useEmbeddedOnboarding'

type Props = {
  trailingComponent?: React.ReactNode
}

export default function Toolbar ({ trailingComponent }: Props) {
  const { isEmbedded } = useEmbeddedOnboarding()
  return (
    <div id='toolbar' className={`${isEmbedded ? '' : 'sticky top-0 z-20 border-b border-gray-200 backdrop-blur-md '}shrink-0 px-4 xs:px-6 py-4`}>
      <div className='flex items-center justify-between'>
        <LogoWithName />
        {trailingComponent && !isEmbedded && trailingComponent}
      </div>
    </div>
  )
}
